/**
 * Main layout component.
 * 
 * @module components/layout/Layout
 */

import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

/**
 * Main layout wrapper with sidebar, header, and content area.
 * 
 * @returns Layout element
 */
export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main content area */}
      <div className="lg:pl-64 min-h-screen flex flex-col">
        {/* Header - fixed position */}
        <Header onMenuClick={() => setSidebarOpen(true)} />

        {/* Page content - pt-16 accounts for fixed header height */}
        <main className="flex-1 p-4 lg:p-6 pt-16">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
